
import {useEffect, useState} from 'react';
import { useLocation, useNavigate } from "react-router-dom";

import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';

import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import s10Logo from '../../assets/images/s10Logo.png';

import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import AppBarMenu from './appBarMenu';
import { Grid } from '@mui/material';
import { Access } from '../../interfaces/auth.interface';
import UserMenu from './UserMenu';
import UserSubMenu from './UserSubMenu';

const drawerWidth = "17.5rem";

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `3.5rem`,
  // [theme.breakpoints.up('sm')]: {
  //   width: `calc(${theme.spacing(8)} + 1px)`,
  // },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  // padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  // backgroundColor: "red",
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    paddingTop: "4rem",
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

const AppMenu = ({ children, setMenuRoute, hiddenHeader }: { children: JSX.Element, setMenuRoute: (route: string[]) => void, hiddenHeader?: boolean}) => {

  const authState = useSelector((state: RootState) => state.auth);
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [menuSelected, setMenuSelected] = useState<Access | null>(null);
  const [subMenuSelected, setSubMenuSelected] = useState<Access | null>(null);

  const findMenuOptions = () => {
    const defaultMenuSelected = `/${["", "/"].includes(location.pathname)
                                  ?  process.env.REACT_APP_DEFAULT_MENU_OPTION
                                  : location.pathname.split("/")[1]}`
    const defaultSubMenuSelected = ["", "/"].includes(location.pathname)
                                  ? process.env.REACT_APP_DEFAULT_SUBMENU_OPTION
                                  : location.pathname
    const portalOption = authState.userMenu.find(m => m.urlPath === defaultMenuSelected);
    const defaultOption = portalOption ? portalOption : authState.userMenu[0];
    setMenuSelected(defaultOption);
    const postOption = defaultOption?.children?.find(m => m.urlPath === defaultSubMenuSelected);
    const defaultSubOption = postOption 
                              ? postOption 
                              : defaultOption?.children 
                                  ? defaultOption?.children[0] 
                                  : null;
    setSubMenuSelected(defaultSubOption);
    setMenuRoute([defaultOption?.Name as any, defaultSubOption?.Name as any])
    if (!menuSelected) {
      if (defaultSubOption?.urlPath) {
        navigate(defaultSubOption.urlPath);
      }
    }

  }

  useEffect(() => {
    findMenuOptions()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authState.userMenu, location.pathname])

  return (
  <Box sx={{ display: 'flex', minHeight: "100%", backgroundColor: "#F5F5F5", width: "100%", }}>
    <CssBaseline />
    {authState.companyselected?.Roles?.Id !== 49 && <AppBarMenu onClick={() => setOpen(!open)} />}
    <Grid container>
      <Grid item>
        {authState.companyselected?.Roles?.Id !== 49 && <Drawer 
          variant="permanent" 
          elevation={0}
          open={open}
          style={{overflowY: "hidden"}}
          PaperProps={{
            sx: {
              color: theme.s10palette.S10Greygrey300,
              backgroundColor: theme.s10palette.S10Greygrey450,
              // background: `linear-gradient(to right, ${theme.s10palette.S10Blueblue700} 0%, ${theme.s10palette.S10Blueblue700} 3.5rem, ${theme.s10palette.S10Blueblue600} 3.5rem, ${theme.s10palette.S10Blueblue600} 100%)`
            }
          }}
        >
          <DrawerHeader style={{marginTop: "4rem", marginLeft: "4rem", padding: "1rem"}}>
            <Grid container direction={"row"} style={{height: "8.81rem"}}>
              <Grid item style={{width: "100%", height: "6rem"}}>
                <img 
                  style={{
                      // width: "8.75rem",
                      width: "6.5rem",
                      // height: "2.5rem",
                  }}
                  src={s10Logo} 
                  alt="S10"
                />
              </Grid>
              <Grid item style={{width: "100%", height: "1.81rem"}}>
                <Typography variant='h6' color={"white"}>
                    {menuSelected?.Name}
                </Typography>
              </Grid>
            </Grid>
          </DrawerHeader>
          <Grid 
            style={{
              // backgroundColor: "red", 
              height: "100%", 
              // marginTop: "4rem"
              overflow: "hidden",
            }} 
            container
            direction={"column"}
          >
            <UserMenu 
              menuSelected={menuSelected} 
              onClick={(itemSelected) => {
                if (open && menuSelected === itemSelected) {
                  // setMenuSelected(null);
                  setOpen(false)
                } else {
                  setMenuSelected(itemSelected);
                  setOpen(true)
                }
              }}   
            />
            <Grid 
              item 
              width={"14rem"} 
              height={"100%"} 
              style={{
                  padding: "0 1rem",
                  borderLeft: theme.s10palette.S10Greygrey350,
                  backgroundColor: theme.s10palette.S10Greygrey350,
              }} 
              sx={{ opacity: open ? 1 : 0 }}
            >
              <Divider
                sx={{
                  backgroundColor: theme.s10palette.S10Greygrey300,
                  height: "0.0625rem",
                  marginBottom: "0.7rem",
                }} 
              />
              
              <UserSubMenu 
                menuSelected={menuSelected}
                subMenuSelected={subMenuSelected}
                onClick={(subMenu) => {
                  setSubMenuSelected(subMenu);
                  navigate(subMenu.urlPath)
                  // setOpen(false);
                }} 
              />
            </Grid>
          </Grid>
        </Drawer>}
      </Grid>
      <Grid item marginLeft="3.5rem" width="-webkit-fill-available" height="100%" style={{backgroundColor: "#F5F5F5",}}>
        <Box 
          component="main" 
          sx={{ 
            width: "100%", 
            top: 0,
            // marginTop: ".3rem", 
            // padding: "1.5rem",
            // mt: { xs: 0, md: "1.5rem" },
            p: {xs: "0 1.5rem 1.5rem 1.5rem", md: `${hiddenHeader ? "0rem" : "1.5rem"} 1.5rem`}
          }}
        >
          {children}
        </Box>
      </Grid>
    </Grid>
  </Box>)
}


export default AppMenu;